import { memo, cloneElement } from "react"

import styled, { css } from "styled-components"

import { spacing, textColorVariables, colors } from "@izettle/otto"

import { Text } from "../text"

import { selectorStates } from "./base"
import { LabelProps, LabelOwnProps, LabelPosition } from "./types"

const LabelContent = styled.div<{ labelPosition: LabelPosition; hidden?: boolean }>`
  display: ${({ hidden }) => (hidden ? "none" : "flex")};
  user-select: none;

  ${({ labelPosition }) =>
    labelPosition === "right"
      ? css`
          margin-left: ${spacing.small};
        `
      : css`
          margin-right: ${spacing.small};
          order: -1;
        `}

  flex-direction: column;
  align-items: flex-start;

  ${selectorStates.invalid} {
    ${`${textColorVariables.secondary}: ${colors.text.error};`}
  }
`

export const Label = memo<LabelProps & LabelOwnProps>(
  ({ label, labelId, message, messageId, labelPosition, hideLabel }) => (
    <LabelContent labelPosition={labelPosition} hidden={hideLabel}>
      {typeof label === "string" ? (
        <Text.Regular id={labelId} as="span" marginTop="none" marginBottom="none">
          {label}
        </Text.Regular>
      ) : (
        cloneElement(label, { id: labelId })
      )}
      {message &&
        (typeof message === "string" ? (
          <Text.SmallSecondary
            id={messageId}
            as="span"
            marginTop="none"
            marginBottom="none"
          >
            {message}
          </Text.SmallSecondary>
        ) : (
          cloneElement(message, { id: messageId })
        ))}
    </LabelContent>
  ),
)
